var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"has-text-centered"},[_vm._v("\n    \t© 2013-"+_vm._s(_vm.currentYear)+" Geneasens SRL - Tous droits réservés.\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }